export const STORE_FAZENDA = "STORE_FAZENDA";

export const storeFazenda = (fazenda) => ({
  type: STORE_FAZENDA,
  fazenda,
});
